import { Space } from 'antd';
import { useFormikContext } from 'formik';
import { UserOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import CountrySelect from 'components/new-ui/composed/selects/CountrySelect';
import { InvoiceFieldValues } from 'views/invoices/types';
import { ControlWrapper, SectionFormLabel, SectionFormRow } from '../styles';

type Props = {
    isReadOnly: boolean;
};

export enum CustomerFieldNames {
    NAME = 'customerDetails.name',
    ADDRESS = 'customerDetails.address',
    CITY = 'customerDetails.city',
    POST_CODE = 'customerDetails.postCode',
    COUNTRY = 'customerDetails.country',
}

const RecipientDetailsSection = ({ isReadOnly }: Props) => {
    const formik = useFormikContext<InvoiceFieldValues>();

    return (
        <CardWithIcon
            gap="medium"
            layout="vertical"
            title="Recipient Details"
            iconProps={{
                size: 32,
                borderRadius: 8,
                status: 'warning',
                icon: <UserOutlined />,
            }}
            children={
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <SectionFormRow>
                        <SectionFormLabel>Name :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled={isReadOnly}
                                placeholder="Enter name"
                                fieldProps={formik.getFieldProps(CustomerFieldNames.NAME)}
                                fieldMeta={formik.getFieldMeta(CustomerFieldNames.NAME)}
                                fieldHelper={formik.getFieldHelpers(CustomerFieldNames.NAME)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Address :</SectionFormLabel>

                        <ControlWrapper>
                            <FormInput
                                disabled={isReadOnly}
                                placeholder="Enter address"
                                fieldProps={formik.getFieldProps(CustomerFieldNames.ADDRESS)}
                                fieldMeta={formik.getFieldMeta(CustomerFieldNames.ADDRESS)}
                                fieldHelper={formik.getFieldHelpers(CustomerFieldNames.ADDRESS)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>City :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled={isReadOnly}
                                placeholder="Enter city"
                                fieldProps={formik.getFieldProps(CustomerFieldNames.CITY)}
                                fieldMeta={formik.getFieldMeta(CustomerFieldNames.CITY)}
                                fieldHelper={formik.getFieldHelpers(CustomerFieldNames.CITY)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Post Code :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled={isReadOnly}
                                placeholder="Enter post code"
                                fieldProps={formik.getFieldProps(CustomerFieldNames.POST_CODE)}
                                fieldMeta={formik.getFieldMeta(CustomerFieldNames.POST_CODE)}
                                fieldHelper={formik.getFieldHelpers(CustomerFieldNames.POST_CODE)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Country :</SectionFormLabel>
                        <ControlWrapper>
                            <CountrySelect
                                hideKeys
                                hideLabel
                                disabled={isReadOnly}
                                placeholder="Select country"
                                fieldMeta={formik.getFieldMeta(CustomerFieldNames.COUNTRY)}
                                fieldProps={formik.getFieldProps(CustomerFieldNames.COUNTRY)}
                                fieldHelper={formik.getFieldHelpers(CustomerFieldNames.COUNTRY)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>
                </Space>
            }
        />
    );
};

export default RecipientDetailsSection;
